module.exports = __webpack_public_path__ + "img/add-desktop-icon.f42a22a.jpg";